import { ADMIN_ROLE, USER_ROLE } from '../../constants/user_profile_constants';
import { CardType } from '../../interfaces';
import { getCardIssuingLimit } from '../cardRequestFormatters';
export function canManagerIssueRequestedCard(company, userProfile, cardType, amount) {
    if (!company.is_manager_card_issuing_enabled) {
        return 'Manager issuing is not enabled';
    }
    if (!amount) {
        return 'Invalid amount.';
    }
    const cardIssueLimit = getCardIssuingLimit(company, [userProfile]);
    let isValidCardRequestAmount;
    if (!cardIssueLimit) {
        // If a limit is not set, manager can issue unlimited amount
        isValidCardRequestAmount = true;
    }
    else {
        isValidCardRequestAmount = amount <= cardIssueLimit;
    }
    if (!isValidCardRequestAmount) {
        return `You can issue cards for the maximum of ${cardIssueLimit}`;
    }
    // is valid if not explicitly set to false and company has physical card issuing enabled
    const isValidCardRequestType = cardType === CardType.Virtual ||
        cardType === CardType.Ghost ||
        (cardType === CardType.Physical && isPhysicalCardIssuingEnabled(company, userProfile));
    if (isValidCardRequestType) {
        return null;
    }
    return `You can't issue this type of card`;
}
export function isPhysicalCardIssuingEnabled(company, userProfile) {
    if (userProfile.role === ADMIN_ROLE) {
        return true;
    }
    if (userProfile.role === USER_ROLE) {
        return false;
    }
    if (!company.is_manager_card_issuing_enabled || !company.can_managers_issue_physical_cards) {
        return false;
    }
    // if not explicitly set, fallback to company settings
    return userProfile.can_issue_physical_cards === undefined
        ? company.can_managers_issue_physical_cards
        : userProfile.can_issue_physical_cards;
}
